import { Component, OnInit } from '@angular/core';
import { CacheService } from './cache.service';
import { UserService } from './user.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [CacheService, UserService],
    encapsulation:  ViewEncapsulation.ShadowDom
})
export class AppComponent implements OnInit {

    constructor(
        private location: Location,
        private router: Router,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.userService.authenticate()
    }

    index(){
        if ( this.location.path().indexOf('/admin/courses-and-events') > -1 ) {
            this.router.navigate(['/admin/courses-and-events']);

        } else {
            this.router.navigate(['/courses-and-events/my-courses-and-events/']);
        }
    }

    get title(){
        return `${!this.userService.isAdmin ? "My " : ""}Courses and Events`;
    }
}